module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-all-500-normal.woff?0ab669b7a0d19b178f57d46f0e0db5cb";